import React from 'react'
import './../Form.css'
import {useFormContext} from "react-hook-form";
import Autocomplete from "react-google-autocomplete";

const REACT_APP_MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY;

const AutocompleteAddress = props => {
    const { id, label, addressType, validation } = props;

    const formBinding = useFormContext();
    const { register, getValues, setValue, formState: { errors } } = formBinding;

    const  addressOptions = {
        types: [addressType],
        componentRestrictions: {country: ["au"]}
    }

    const addressAction = (place) => {
        if(addressType === 'address'){
            setValue('address', place.formatted_address );
            for (const component of place.address_components) {
                const componentType = component.types[0];
                switch (componentType) {
                    case "administrative_area_level_1": {
                        setValue('state', component.short_name )
                        break;
                    }
                    default:
                        break;
                }
            }
            const location = JSON.parse(JSON.stringify(place.geometry.location));
            setValue('latitude', location.lat );
            setValue('longitude', location.lng );
        } else {
            let postalCode = "";
            for (const component of place.address_components) {
                const componentType = component.types[0];
                switch (componentType) {
                    case "colloquial_area":
                    case "locality":
                        document.querySelector("#city").value = component.short_name;
                        setValue('city', component.short_name);
                        break;
                    case "administrative_area_level_1": {
                        setValue('state', component.short_name);
                        break;
                    }
                    case "postal_code": {
                        postalCode = `${component.long_name}${postalCode}`;
                        break;
                    }
                    case "postal_code_suffix": {
                        postalCode = `${postalCode}-${component.long_name}`;
                        break;
                    }
                    default:
                        break;
                }
            }
            setValue('postalCode', postalCode);
        }
    }

    return (
        <>
        {
            <div className="form-element">
                <label>{label}</label>
                <Autocomplete
                    id={id}
                    apiKey={REACT_APP_MAP_API_KEY} 
                    options={addressOptions}
                    defaultValue={getValues(id)}
                    onPlaceSelected={(place) => addressAction(place)}
                    {...register(id, validation)}
                />
                {errors[id] && <p className="input-error">{errors[id].message}</p>}
            </div>
        }
        </>
    )
}

export default AutocompleteAddress
